import builder from './builder';
import SearchForm from 'app/components/search-results/SearchForm';
import ResultList from 'app/components/search-results/SearchResults/Desktop';

/**
 * Page component for displaying Mozio's Search Results page.
 */
export const SearchResultsPage = builder({
  SearchForm,
  ResultList
});

export default SearchResultsPage;
